import { Box } from "@mui/material";
import React, { useState } from "react";

import { Dropzone } from "components/common/Dropzone/Dropzone";
import { Modal } from "new-components/modals/Modal";

interface ImageModalProps {
  open: boolean;
  onClose: () => void;
  addImage: (image: File) => void;
}

export function ImageModal(props: ImageModalProps) {
  const { open, onClose, addImage } = props;
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <Modal
      size="medium"
      open={open}
      onClose={onClose} // Prevent immediate close if it's in the process of closing
      title="Add Images"
      onCancel={onClose}
      body={
        <Box p={4} width="100%" height="100%">
          <Dropzone
            onClose={onClose}
            onDrop={(files) => addImage(files[0])}
            maxFiles={1}
            loading={false}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </Box>
      }
    />
  );
}
